import request from '@/utils/request';
import { func } from 'prop-types';

export function queryHISList(data) {
  return request('/apis/reservation/search2', {
    data
  });
}

export function queryRoomOverview(data) {
  return request('/apis/reservation/getSchdRoomsInfo', {
    data
  });
}

export function queryReserveList(data) {
  return request('/apis/reservation/reservationList', {
    data
  });
}

export function queryRoomScheduleInfo(data) {
  return request('/apis/reservation/getSingleSchdRoomsInfo', {
    data
  });
}

export function saveReservation(data) {
  return request('/apis/reservation/addReservation4Web', {
    data,
    method: 'post'
  });
}

export function reserveConfirm(data) {
  return request('/apis/reservation/check', {
    data,
    method: 'post'
  });
}

export function reserveCancel(data) {
  return request('/apis/reservation/cancel', {
    data,
    method: 'post'
  });
}

export function reserveMove(data) {
  return request('/apis/reservation/move', {
    data,
    method: 'post'
  });
}

export function getReservation(data) {
  return request('/apis/reservation/getById', {
    data
  });
}

export function getReservePrinting(data) {
  return request('/apis/reservation/getById2', {
    data
  })
}

export function checkToReserved (data) {
  return request('/apis/reservation/checkToResed', {
    data
  })
}

export function queryHIS4Room (data) {
  return request('/apis/reservation-h5/listPaidByPid', {
    data
  })
}

export function getMaxResDay () {
  return request('/apis/reservation-h5/getMaxResDays')
}

export function getH5Schd (data) {
  return request(`/apis/reservation-h5/getSchdRoomsInfo4H5?date=${data.date}`, {
    data: data.ids,
    method: 'post'
  })
}

export function roomReserve (data) {
  return request(`/apis/reservation-h5/addREservation4H5`, {
    data,
    method: 'post'
  })
}

export function modifyItems (data) {
  return request(`/apis/reservation/changeCheckItems`, {
    data,
    method: 'post'
  })
}

export function updateReservationStatus(data) {  
  return request(`/apis/reservation/update_reservation_status`, {
    data,
    method: 'PUT'
  })
}

// 用户当前所在诊所的预约
export function queryReservationList(data) {  
  return request(`/apis/reservation/list_by`, {
    method: 'post',
    data
  })
}

// 删除预约
export function deleteReservaion(data) {
  return request(`/apis/reservation/delete/${data.id}`, {
    method: 'DELETE',
  })
}
